import { SERVER_ROUTES } from '@/config/routes/server-routes';
import { ServerResponse } from '@/shared/types/server/response/server-response';
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { Env } from '../environment/env';

export class ServerApi {
  public constructor(private api: AxiosInstance) {}

  public static createByUrl(url: string) {
    const { origin } = new URL(url);

    const api = axios.create({
      baseURL: Env.NEXT_PUBLIC_URL || origin,
      headers: {
        'x-client-url': url,
      },
    });

    return new ServerApi(api);
  }

  public async request<ResponseData = unknown>(
    route: keyof typeof SERVER_ROUTES,
    body?: any,
    opts?: AxiosRequestConfig & {
      replace?: [string, string][];
    },
  ): Promise<ServerResponse<ResponseData>> {
    let url: string = SERVER_ROUTES[route].path;

    if (opts?.replace) {
      for (const replace of opts.replace) {
        const [search, newValue] = replace;
        url = url.replace(search, newValue);
      }
    }

    const res = await this.api({
      url,
      method: SERVER_ROUTES[route].method.toLowerCase(),
      data: body,
      ...opts,
    });

    return res.data; // Retorna o body da response.
  }
}
